import React from 'react';
import { translate } from '@utils/i18n';
import { Button } from '@ui/atoms/Button';
const namespace = 'features.inspections_answer_by_type';
export function AnswersByTypeToolbar({ showCheckbox, canGenerateIndividualReports, allChecked, isEmpty, generatableSelCount, onToggleAll, onGenerateSelected }) {
    if (!showCheckbox && !canGenerateIndividualReports)
        return null;
    return (React.createElement("div", { className: "qmb-toolbar" },
        showCheckbox && (React.createElement(Button, { variant: "secondary", onClick: onToggleAll, disabled: isEmpty },
            React.createElement("i", { className: "fa-regular fa-square-check", "aria-hidden": "true" }),
            allChecked
                ? translate('toolbar.clear_selection', { namespace })
                : translate('toolbar.select_all', { namespace }))),
        canGenerateIndividualReports && (React.createElement(Button, { variant: "primary", disabled: generatableSelCount === 0, onClick: onGenerateSelected },
            React.createElement("i", { className: "fa-solid fa-arrows-rotate", "aria-hidden": "true" }),
            generatableSelCount > 0
                ? translate('toolbar.generate_selected_count', { namespace, count: generatableSelCount })
                : translate('toolbar.generate_selected', { namespace })))));
}
